import React from 'react';
import AppNavbar from '../components/AppNavbar';
import BottomNavigation from '../components/BottomNavigation';
import { navigationItems } from './NavigationConfig';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

interface AppNavigationProps {
  children?: React.ReactNode;
}

/**
 * AppNavigation - A reusable component that provides consistent navigation
 * across all pages of the application. It includes both the top AppNavbar
 * and the mobile BottomNavigation.
 */
const AppNavigation: React.FC<AppNavigationProps> = ({ children }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* Top Navigation Bar */}
      <AppNavbar />
      
      {/* Main Content */}
      <Container fluid className="flex-grow-1" style={{ marginTop: 0, paddingTop: '1rem', paddingBottom: '70px' }}>
        {children || <Outlet />}
      </Container>
      
      {/* Mobile Bottom Navigation */}
      <BottomNavigation navigationItems={navigationItems} />
    </div>
  );
};

export default AppNavigation;
